import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { Linkedin, Mail, Github, MapPin } from 'lucide-react';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="border-t border-border bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div data-reveal="out" className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <h3 className="font-mono tracking-[0.12em] text-lg font-semibold">Patrizio Sbardella</h3>
            <p className="mt-4 text-muted-foreground">{t.footer.tagline}</p>
            <div className="mt-4 inline-flex items-center gap-2 text-muted-foreground">
              <MapPin className="w-4 h-4" />
              <span>{t.footer.location}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.35em] text-muted-foreground">
              {language === 'de' ? 'Navigation' : 'Navigation'}
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="font-mono tracking-[0.12em] hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                >
                  {t.nav.about}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="font-mono tracking-[0.12em] hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                >
                  {t.nav.services}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('skills')}
                  className="font-mono tracking-[0.12em] hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                >
                  {t.nav.skills}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('experience')}
                  className="font-mono tracking-[0.12em] hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                >
                  {t.nav.experience}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="font-mono tracking-[0.12em] hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
                >
                  {t.nav.contact}
                </button>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.35em] text-muted-foreground">
              {language === 'de' ? 'Kontakt' : 'Contact'}
            </h4>
            <div className="mt-4 space-y-3">
              <a
                href="mailto:sbardella@sbardella.de"
                className="flex items-center gap-3 font-mono tracking-[0.12em] hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              >
                <Mail className="w-5 h-5" />
                Email
              </a>
              <a
                href="https://www.linkedin.com/in/patrizio-sbardella/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 font-mono tracking-[0.12em] hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              >
                <Linkedin className="w-5 h-5" />
                LinkedIn
              </a>
              <a
                href="https://github.com/sbardella77"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 font-mono tracking-[0.12em] hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              >
                <Github className="w-5 h-5" />
                GitHub
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8 text-center">
          <p className="text-muted-foreground">
            &copy; {new Date().getFullYear()} Patrizio Sbardella. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
